module.exports = __webpack_public_path__ + "img/time.15026fe9.png";